import { Autocomplete, Box, Button, Card, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { getChangeReasons } from 'src/store/slices/assigmentSlice';
import { useDispatch } from 'react-redux';
import { fillMainProductGroups, secondMainProductGroups, thirdMainProductGroups, showList, deleteAutomaticApprovalChangeReason, xd, insertDeletedAutomaticApprovalChangeReason, deletedAutomaticApprovalChangeReasonShowList } from 'src/store/slices/dynamicCatalogSlice';
import { DataGrid, trTR } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AlertAndLoading from 'src/components/AlertAndLoading';
import { getUser } from 'src/utils/Common';
import moment from 'moment';
import {
  DARK,
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  listboxProps,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';

const gridLocale = { ...trTR.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: 'Kayıt bulunamadı.' };
const SEARCH_FIELDS = ['ACIKLAMA', 'ACIKLAMA2', 'ACIKLAMA3', 'NEDEN', 'SICIL_NO'];
const toList = (payload) => (Array.isArray(payload) ? payload : []);

function OtomaticApprovalDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();

  const [changeReason, setChangeReason] = React.useState([]);
  const [mainProductGroups, setMainProductGroups] = React.useState([]);
  const [secondProductGroups, setSecondProductGroups] = React.useState([]);
  const [thirdProductGroups, setThirdProductGroups] = React.useState([]);
  const [showLists, setShowLists] = React.useState([]);
  const [deletedShowLists, setDeletedShowLists] = React.useState([]);
  // Combo seçimleri (seçilen option nesneleri)
  const [mainProduct, setMainProduct] = React.useState(null);
  const [secondMainProduct, setSecondMainProduct] = React.useState(null);
  const [thirdMainProduct, setThirdMainProduct] = React.useState(null);
  const [exchangeReason, setExchangeReason] = React.useState(null);
  const [secondLoading, setSecondLoading] = React.useState(false);
  const [thirdLoading, setThirdLoading] = React.useState(false);
  const [listLoading, setListLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const [listView, setListView] = React.useState('active');
  const [searchText, setSearchText] = React.useState('');
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });

  const loadActiveList = () => {
    setListLoading(true);
    return dispatch(showList()).then(response => {
      if (response.meta?.requestStatus === 'fulfilled') setShowLists(toList(response.payload));
      setListLoading(false);
    });
  };

  const loadDeletedList = () => {
    return dispatch(deletedAutomaticApprovalChangeReasonShowList()).then(response => {
      if (response.meta?.requestStatus === 'fulfilled') setDeletedShowLists(toList(response.payload));
    });
  };

  useEffect(() => {
    dispatch(getChangeReasons()).then(response => {
      setChangeReason(toList(response?.payload))
    });
    dispatch(fillMainProductGroups()).then(response => {
      setMainProductGroups(toList(response.payload))
    });
    loadActiveList();
    loadDeletedList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    })
    setUyari(true);
    return
  }

  // Üst grup değişince alt seviyeler sıfırlanır
  function onMainProductChange(val) {
    setMainProduct(val);
    setSecondMainProduct(null);
    setThirdMainProduct(null);
    setSecondProductGroups([]);
    setThirdProductGroups([]);
    if (val?.Value) {
      setSecondLoading(true);
      dispatch(secondMainProductGroups(val.Value.toString())).then(response => {
        setSecondProductGroups(toList(response?.payload))
        setSecondLoading(false);
      });
    }
  }

  function onSecondProductChange(val) {
    setSecondMainProduct(val);
    setThirdMainProduct(null);
    setThirdProductGroups([]);
    if (val?.Value) {
      setThirdLoading(true);
      dispatch(thirdMainProductGroups(val.Value.toString())).then(response => {
        setThirdProductGroups(toList(response?.payload))
        setThirdLoading(false);
      });
    }
  }

  function DeleteRow() {
    const row = deleteTarget;
    if (!row) return;
    const data = {
      DeletedDsc: row.ACIKLAMA,
      DeletedSecondDsc: row.ACIKLAMA2,
      DeletedThirdDsc: row.ACIKLAMA3,
      DeletedExchangeReason: row.NEDEN,
      SessionUser: SessionUser?.FirstName + " " + SessionUser?.LastName
    }
    setSaving(true);
    Promise.all([
      dispatch(deleteAutomaticApprovalChangeReason([row.ID])),
      dispatch(insertDeletedAutomaticApprovalChangeReason(data))
    ]).then(() => {
      setSaving(false);
      setDeleteTarget(null);
      loadActiveList();
      loadDeletedList();
    });
  }

  function InsertRow() {
    if (!mainProduct || !secondMainProduct || !thirdMainProduct || !exchangeReason) {
      InfoAlert('Lütfen Kutucukları Boş Bırakmayınız!...', 'error', 'Hata');
      return;
    }

    const data = {
      Dsc: mainProduct.Value,
      SecondDsc: secondMainProduct.Value,
      ThirdDsc: thirdMainProduct.Value,
      ExchangeReason: exchangeReason.Id,
      SessionUser: SessionUser?.FirstName + " " + SessionUser?.LastName
    }

    setSaving(true);
    dispatch(xd(data)).then(response => {
      setSaving(false);
      if (response.payload?.ErrorCode && response.payload.ErrorCode !== '0') {
        InfoAlert(response.payload.ErrorDescription, 'error', 'Hata');
        return;
      }
      InfoAlert('Kural eklendi.', 'success', 'Başarılı');
      setListView('active');
      loadActiveList();
    })
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const baseColumns = [
    { field: 'ACIKLAMA', headerName: 'Ana Ürün Grubu', flex: 1, minWidth: 150 },
    { field: 'ACIKLAMA2', headerName: '2. Seviye Ürün Grubu', flex: 1, minWidth: 150 },
    { field: 'ACIKLAMA3', headerName: '3. Seviye Ürün Grubu', flex: 1, minWidth: 150 },
    { field: 'NEDEN', headerName: 'Değişim Nedeni', flex: 1.2, minWidth: 170 }
  ];

  const columns = [
    ...baseColumns,
    {
      field: 'EKLEME_TARIHI', headerName: 'Ekleme Tarihi', width: 120,
      valueFormatter: (p) => (p.value ? moment(p.value).format('DD.MM.YYYY') : '')
    },
    { field: 'SICIL_NO', headerName: 'Ekleyen', width: 150 },
    {
      field: 'Sil', headerName: 'İşlem', width: 80, align: 'center', headerAlign: 'center',
      sortable: false, filterable: false, disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Tooltip title="Sil">
          <IconButton size="small" onClick={() => setDeleteTarget(cellValues.row)}>
            <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e53935' }} />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  // Silinmiş kurallar tablosunda tarih ve kişi silme işlemine aittir
  const deletedColumns = [
    ...baseColumns,
    {
      field: 'EKLEME_TARIHI', headerName: 'Silinme Tarihi', width: 150,
      valueFormatter: (p) => (p.value ? moment(p.value).format('DD.MM.YYYY HH:mm') : '')
    },
    { field: 'SICIL_NO', headerName: 'Silen', width: 150 }
  ];

  const isActiveView = listView === 'active';
  const currentRows = useMemo(() => filterDynamicRows(isActiveView ? showLists : deletedShowLists, {
    searchText,
    searchFields: SEARCH_FIELDS
  }), [isActiveView, showLists, deletedShowLists, searchText]);

  const comboProps = {
    size: 'small',
    fullWidth: true,
    ListboxProps: listboxProps,
    noOptionsText: 'Seçenek yok'
  };

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Yeni kural */}
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            title="Yeni Otomatik Onay Kuralı"
          />
          <Box sx={{ p: 2, opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
            <Grid container spacing={1.5} alignItems="center">
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={mainProductGroups}
                  value={mainProduct}
                  getOptionLabel={(option) => option.Display || ''}
                  isOptionEqualToValue={(o, v) => o.Value === v.Value}
                  onChange={(event, val) => onMainProductChange(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="Ana Ürün Grubu" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={secondProductGroups}
                  value={secondMainProduct}
                  loading={secondLoading}
                  loadingText="Yükleniyor…"
                  disabled={!mainProduct}
                  getOptionLabel={(option) => option.Display || ''}
                  isOptionEqualToValue={(o, v) => o.Value === v.Value}
                  onChange={(event, val) => onSecondProductChange(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="2. Seviye Ürün Grubu" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={thirdProductGroups}
                  value={thirdMainProduct}
                  loading={thirdLoading}
                  loadingText="Yükleniyor…"
                  disabled={!secondMainProduct}
                  getOptionLabel={(option) => option.Display || ''}
                  isOptionEqualToValue={(o, v) => o.Value === v.Value}
                  onChange={(event, val) => setThirdMainProduct(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="3. Seviye Ürün Grubu" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={changeReason}
                  value={exchangeReason}
                  getOptionLabel={(option) => option.Dsc || ''}
                  isOptionEqualToValue={(o, v) => o.Id === v.Id}
                  onChange={(event, val) => setExchangeReason(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="Değişim Nedeni - Detayı" />}
                />
              </Grid>
              <Grid item xs={12} lg={1.6}>
                <Button
                  fullWidth
                  startIcon={saving && !deleteTarget ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : <AddIcon />}
                  sx={darkButtonSx}
                  disabled={saving || !mainProduct || !secondMainProduct || !thirdMainProduct || !exchangeReason}
                  onClick={InsertRow}
                >
                  Kural Ekle
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Card>

        {/* Kurallar */}
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            title="Otomatik Onay Kuralları"
            subheader={listLoading ? 'Yükleniyor…' : `${showLists.length} aktif · ${deletedShowLists.length} silinmiş`}
          />
          <DynamicListToolbar
            searchText={searchText}
            onSearchChange={setSearchText}
            placeholder="Ürün grubu, neden veya kişi ara"
            shownCount={currentRows.length}
          >
            <Box sx={{ width: 300 }}>
              <ToggleButtonGroup
                exclusive
                size="small"
                className={classes.toggleGroup}
                value={listView}
                onChange={(e, v) => v !== null && setListView(v)}
              >
                <ToggleButton value="active">Aktif Kurallar ({showLists.length})</ToggleButton>
                <ToggleButton value="deleted">Silinmiş ({deletedShowLists.length})</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </DynamicListToolbar>
          <DataGrid
            key={listView}
            className={classes.grid}
            style={{ height: 480, width: '100%' }}
            rows={currentRows}
            columns={isActiveView ? columns : deletedColumns}
            loading={isActiveView && listLoading}
            rowHeight={44}
            headerHeight={44}
            disableSelectionOnClick
            getRowId={(row) => row.ID}
            localeText={gridLocale}
          />
        </Card>
      </Box>

      {/* Silme onayı */}
      <Dialog open={!!deleteTarget} onClose={() => !saving && setDeleteTarget(null)} fullWidth maxWidth="xs" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          Kural Sil
          <IconButton size="small" onClick={() => setDeleteTarget(null)} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important' }}>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <WarningAmberIcon sx={{ color: ORANGE, mt: '2px' }} />
            <Box sx={{ fontSize: '13px', color: DARK }}>
              Aşağıdaki kural silinecek ve silinmiş kurallara taşınacak. Emin misiniz?
              <Box sx={{ mt: 1.5, p: '8px 12px', borderRadius: '10px', backgroundColor: '#fafafa', border: '1px solid #e0e0e0', fontSize: '12px', lineHeight: 1.7 }}>
                <div>{deleteTarget?.ACIKLAMA} › {deleteTarget?.ACIKLAMA2} › {deleteTarget?.ACIKLAMA3}</div>
                <div><b>{deleteTarget?.NEDEN}</b></div>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={() => setDeleteTarget(null)} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 90, color: '#fff', backgroundColor: '#e53935', '&:hover': { backgroundColor: '#c62828' } }}
            onClick={DeleteRow}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}
          >
            Sil
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default OtomaticApprovalDynamic;
